// Trilingual copy for the Belgian eID verification error banner. Keyed by
// category — the C# / native side ships a numeric Code which the helper in
// `@app/dev/constants/belgianVerification.js` maps to one of these keys.
//
// Strings are intentionally NOT routed through `t()` — Belgian eID rules
// require all three locales to be visible regardless of the active skin
// language, so the i18n grid stack renders every variant simultaneously
// (only the active one is opaque; rotation cycles through them).
export const BELGIAN_ERROR_MESSAGES = {
  excluded: {
    en: {
      title: 'Access denied',
      body: 'You are registered in the EPIS exclusion register and may not play. For questions, please contact the Belgian Gaming Commission. Please remove your card.',
    },
    fr: {
      title: 'Accès refusé',
      body: "Vous êtes inscrit(e) au registre EPIS des personnes exclues et ne pouvez pas jouer. Pour toute question, veuillez contacter la Commission des jeux de hasard. Veuillez retirer votre carte.",
    },
    nl: {
      title: 'Toegang geweigerd',
      body: 'U bent ingeschreven in het uitsluitingsregister EPIS en kunt niet spelen. Voor vragen kunt u contact opnemen met de Kansspelcommissie. Gelieve uw kaart te verwijderen.',
    },
  },
  under_age: {
    en: {
      title: 'Age restriction',
      body: 'You must be 18 or older to play. Please remove your card.',
    },
    fr: {
      title: "Restriction d'âge",
      body: 'Vous devez avoir 18 ans ou plus pour jouer. Veuillez retirer votre carte.',
    },
    nl: {
      title: 'Leeftijdsbeperking',
      body: 'U moet 18 jaar of ouder zijn om te spelen. Gelieve uw kaart te verwijderen.',
    },
  },
  expired: {
    en: {
      title: 'Card expired',
      body: 'Your electronic ID card has expired. Please renew your card at your municipality.',
    },
    fr: {
      title: 'Carte expirée',
      body: "Votre carte d'identité électronique a expiré. Veuillez la renouveler auprès de votre commune.",
    },
    nl: {
      title: 'Kaart verlopen',
      body: 'Uw elektronische identiteitskaart is verlopen. Gelieve uw kaart te vernieuwen bij uw gemeente.',
    },
  },
  unreadable: {
    en: {
      title: 'Card not readable',
      body: 'Your card could not be read. Please reinsert it or ask staff for assistance.',
    },
    fr: {
      title: 'Carte illisible',
      body: "Votre carte n'a pas pu être lue. Veuillez la réinsérer ou demander de l'aide au personnel.",
    },
    nl: {
      title: 'Kaart onleesbaar',
      body: 'Uw kaart kon niet worden gelezen. Gelieve uw kaart opnieuw in te steken of het personeel om hulp te vragen.',
    },
  },
  unavailable: {
    en: {
      title: 'Verification unavailable',
      body: 'The verification service is temporarily unavailable. Please ask staff to assist you.',
    },
    fr: {
      title: 'Service indisponible',
      body: 'Le service de vérification est temporairement indisponible. Veuillez demander de l\'aide au personnel.',
    },
    nl: {
      title: 'Verificatie niet beschikbaar',
      body: 'De verificatiedienst is tijdelijk niet beschikbaar. Gelieve het personeel om hulp te vragen.',
    },
  },
};
